import { getCode, getData } from "country-list";

export const isMobileDevice = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  };
  export let currencyType = {
  "PKR": {
   // replace with your actual PKR image
    code: "Rs.",
    name: "Pakistani Rupee"
  },
  "USD": {
      // replace with your actual USD image
    code: "$",
    name: "US Dollar"
  },
  "AED": {
       // replace with your actual AED image
    code: "AED",
    name: "UAE Dirham"
  }
};


export const getCountryCode = (countryName) => {
  if (!countryName) return null;

  const countries = Object.fromEntries(
    getData().map(c => [c.name.toLowerCase(), c.code])
  );

  return countries[countryName.toLowerCase()] || null;
};
